/**
 * Central MLS vendor hub — logos + admin / apply / docs links.
 * Used by VendorsPage (`/vendors`).
 */

function favicon(domain) {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`
}

export const VENDOR_HUB = [
  {
    id: 'mls-grid',
    name: 'MLS Grid',
    vendorKey: 'mls_grid',
    status: 'live',
    blurb: 'Your current vendor path. Stellar + other Grid boards. Data License Requests in admin.',
    logoUrl: favicon('mlsgrid.com'),
    domain: 'mlsgrid.com',
    links: [
      { label: 'Vendor admin', href: 'https://app.mlsgrid.com/admin', primary: true },
      { label: 'Register / apply', href: 'https://app.mlsgrid.com/register' },
      { label: 'Vendors list', href: 'https://www.mlsgrid.com/vendors' },
      { label: 'API docs', href: 'https://docs.mlsgrid.com/api-documentation/api-version-2.0' },
    ],
    internalDoc: '/docs/mls-grid',
  },
  {
    id: 'trestle',
    name: 'Trestle (Cotality)',
    vendorKey: 'trestle',
    status: 'live',
    blurb: 'Live for Brokurz. Portal login: reso@brokurz.com (password in local .env as TRESTLE_PORTAL_PASSWORD). Add MLO connections in the dashboard; API sync uses client id/secret, not the portal password.',
    logoUrl: favicon('trestle.corelogic.com'),
    domain: 'trestle.corelogic.com',
    links: [
      { label: 'Dashboard / login', href: 'https://trestle.corelogic.com', primary: true },
      { label: 'Subscription wizard', href: 'https://trestle.corelogic.com/SubscriptionWizard' },
      { label: 'Product page', href: 'https://www.cotality.com/products/trestle' },
      { label: 'FAQ / docs', href: 'https://trestle-documentation.corelogic.com/faq.html' },
      { label: 'Tech provider PDF', href: 'https://trestle.corelogic.com/Content/Trestle%20for%20Technology%20Providers%20Release%20v3.pdf' },
    ],
    internalDoc: '/docs/mls-vendor',
  },
  {
    id: 'bridge',
    name: 'Bridge Interactive',
    vendorKey: 'bridge_interactive',
    status: 'live',
    blurb: 'Live for Brokurz. RESO Web API for many boards (incl. Bright path). Request datasets in the dashboard; MLS approval still required per board.',
    logoUrl: favicon('bridgedataoutput.com'),
    domain: 'bridgedataoutput.com',
    links: [
      { label: 'Dashboard', href: 'https://bridgedataoutput.com/', primary: true },
      { label: 'Register', href: 'https://bridgedataoutput.com/register' },
      { label: 'Signup docs', href: 'https://bridgedataoutput.com/docs/platform/Introduction/Signing-up-with-Bridge-API' },
      { label: 'Developers', href: 'https://www.bridgeinteractive.com/developers/bridge-api/' },
      { label: 'Email Bridge', href: 'mailto:BridgeAPI@bridgeinteractive.com' },
    ],
    internalDoc: '/docs/mls-vendor',
  },
  {
    id: 'bright',
    name: 'Bright MLS',
    vendorKey: 'other',
    status: 'apply',
    blurb: 'Not on MLS Grid. Become an approved IDX/VOW vendor (often via Bridge) then request Bright dataset.',
    logoUrl: favicon('brightmls.com'),
    domain: 'brightmls.com',
    links: [
      { label: 'Approved vendors', href: 'https://www.brightmls.com/bright-mls-approved-idx-vow-vendors', primary: true },
      { label: 'Vendor login', href: 'https://accountsettings.brightmls.com/Vendor/login?locale=us' },
      { label: 'Bright home', href: 'https://www.brightmls.com/' },
      { label: 'Support', href: 'https://support.brightmls.com/' },
    ],
    internalDoc: '/docs/mls-vendor',
  },
  {
    id: 'spark',
    name: 'Spark / FBS',
    vendorKey: 'other',
    status: 'reference',
    blurb: 'Flexmls / Spark API used by some MLS boards. Apply via the MLS or FBS partner programs when a board requires it.',
    logoUrl: favicon('fbsdata.com'),
    domain: 'fbsdata.com',
    links: [
      { label: 'FBS / Spark', href: 'https://www.fbsdata.com/', primary: true },
      { label: 'Spark API docs', href: 'https://sparkplatform.com/docs/' },
    ],
    internalDoc: '/docs/mls-vendor',
  },
  {
    id: 'reso',
    name: 'RESO',
    vendorKey: null,
    status: 'reference',
    blurb: 'Industry standards for Web API + Data Dictionary. Not a feed vendor — reference for certification and MLS list.',
    logoUrl: favicon('reso.org'),
    domain: 'reso.org',
    links: [
      { label: 'RESO home', href: 'https://www.reso.org/', primary: true },
      { label: 'US MLS list', href: 'https://www.reso.org/mls-list/' },
      { label: 'Web API', href: 'https://www.reso.org/reso-web-api/' },
    ],
    internalDoc: '/docs/mls-vendor',
  },
]

export const VENDOR_QUICK_OPS = [
  { label: 'Applications', to: '/applications', hint: 'Pending Brokurz MLS requests' },
  { label: 'Boards', to: '/boards', hint: 'feeds status / credential_ref' },
  { label: 'Config', to: '/config', hint: 'Wire sources → warehouse' },
  { label: 'MLS vendor docs', to: '/docs/mls-vendor', hint: 'Fees, model, licensing' },
]
